import { Base } from './base';
import '@gnyio/interfaces';
import '../connection';
export class Burn {
    constructor(connection) {
        this.base = new Base(connection);
    }
    async getAll(limit, offset, senderId) {
        const params = {
            limit: limit,
            offset: offset,
            senderId: senderId,
        };
        const res = await this.base.get('/api/burn/', params);
        const result = res.data;
        return result;
    }
}
//# sourceMappingURL=burn.js.map